import type { ResolveLiveTabPeriodLabelParams } from '../types';

const resolveLiveTabPeriodLabel = ({
    periodLabel,
    isLoading,
    hasError,
}: ResolveLiveTabPeriodLabelParams): string => {
    if (periodLabel) {
        return periodLabel;
    }

    if (hasError) {
        return 'Unavailable';
    }

    if (isLoading) {
        return 'Loading…';
    }

    return 'Unavailable';
};

export default resolveLiveTabPeriodLabel;
